import React from 'react'
import {Link} from '@material-ui/core'
import './D6_SL_Footer_CSS.css'

const D6_SL_Footer = () => {
    return (
        <div className="D6_SL_Footer_Items">
            {/* <div className="D6_SL_Footer_Items_NavLink D6_SL_Footer_Items_NavLink1">
                    <Link className="D6_SL_Footer_Items_Link" href="https://www.dec6.in/AboutUs" target='_blank'>
                            ABOUT 
                    </Link>
                </div>
                <div className="D6_SL_Footer_Items_NavLink D6_SL_Footer_Items_NavLink2">
                    <Link className="D6_SL_Footer_Items_Link" href="https://www.dec6.in/PrivacyPolicy" target='_blank'>
                            PRIVACY POLICY
                    </Link>
                </div>
                <div className="D6_SL_Footer_Items_NavLink D6_SL_Footer_Items_NavLink3">
                    <Link className="D6_SL_Footer_Items_Link" href="https://www.dec6.in/Terms&Conditions" target='_blank'>
                            TERMS &amp; CONDITIONS
                    </Link>
                </div>
                
                <div className="D6_SL_Footer_Items_NavLink D6_SL_Footer_Items_NavLink4">  
                    <Link className="D6_SL_Footer_Items_Link" href="mailto:connect@halodigital.app" >
                        CONTACT US
                    </Link>
                </div> */}
                <div className="D6_SL_Footer_Items_P_Div">  
                    <Link className="D6_SL_Footer_Items_P" href="https://www.dec6.in" target='_blank'>
                        &#169;2025 Dec6 Consulting Private Limited
                    </Link>
                </div>
                
        </div>
    )
}

export default D6_SL_Footer
